var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-default-overlay is-active" }, [
    _c(
      "button",
      {
        staticClass: "close-button c-overlay-close-button",
        attrs: { "aria-label": "Close alert", type: "button" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close.apply(null, arguments)
          }
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-default-overlay-wrapper" }, [
      _vm.usp.overlay_title
        ? _c("h2", { staticClass: "c-heading-large" }, [
            _vm._v(_vm._s(_vm.usp.overlay_title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.usp.article_image
        ? _c("img", {
            attrs: {
              src: _vm.changeImageSize(
                _vm.usp.article_image.media_path,
                550,
                "_"
              ),
              alt: _vm.usp.article_image.media_title
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.usp.overlay_description
        ? _c("p", {
            staticClass: "u-margin-top-medium",
            domProps: { innerHTML: _vm._s(_vm.usp.overlay_description) }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b2a5088", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b2a5088","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/components/usps/usp-popup.vue
// module id = 247
// module chunks = 3